export default __webpack_public_path__ + "static/Perfect2-013d19dd7bc05b9cb9e24a2ed63d6793.jpg";